import React, { useState } from "react"
import { View, StyleSheet } from "react-native"
import { NestedRowTableBase } from "./NestedRowTableBase"
import { ExpandedNestedRowTable } from "./ExpandedNestedRowTable"
import type { ColumnDefinition } from "../../types/project"

interface NestedRowTableProps<T> {
    data: T[]
    columns: ColumnDefinition[]
    levelKey: string
    childrenKey: string
    tableName: string
    defaultVisibleColumns?: string[]
    title?: string
    OnExpandedButtonClick?: () => void
    menuAction?: {
        type: "columnOptions" | "expandTable"
        visible: boolean
      }
}

export function NestedRowTable<T extends Record<string, any>>({ OnExpandedButtonClick, ...props }: NestedRowTableProps<T>) {
    const [isExpanded, setIsExpanded] = useState(false)

    const handleExpandButtonClick = () => {
        setIsExpanded(true)
    }

    return (
        <View style={styles.container}>
            <NestedRowTableBase
                {...props}
                OnExpandedButtonClick={handleExpandButtonClick}
            />
            {!OnExpandedButtonClick && (
                <ExpandedNestedRowTable
                    {...props}
                    visible={isExpanded}
                    onDismiss={() => setIsExpanded(false)}
                />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
})
